/**
 * 描述：编辑租户
 * 日期：2017-11-7
 * 作者：liujinming
 */
'use strict';
angular.module('createNewReportModule', [])
    .controller('createNewReportCtrl', ['$scope', '$rootScope', '$modalInstance', 'localStorageService', 'item', '$sce', 'trsHttpService', 'modalDialog', '$timeout', '$compile', 'commandService', '$q', '$validation', '$element', '$sessionStorage',
        function($scope, $rootScope, $modalInstance, localStorageService, item, $sce, trsHttpService, modalDialog, $timeout, $compile, commandService, $q, $validation, $element, $sessionStorage) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    reportTypeList: [{ // 报题类型
                        name: '普通',
                        value: 1
                    }, {
                        name: '重要',
                        value: 2
                    }, {
                        name: '紧急',
                        value: 3
                    }, {
                        name: '敏感',
                        value: 4
                    }],
                    channels: [{ // 发稿渠道
                        text: '文字',
                        key: 1,
                    }, {
                        text: '图片',
                        key: 2,
                    }, {
                        text: '视频',
                        key: 3,
                    }, {
                        text: '直播',
                        key: 4,
                    }, {
                        text: '可视化',
                        key: 5,
                    }, {
                        text: 'H5',
                        key: 6,
                    }, {
                        text: 'AR',
                        key: 7,
                    }],
                    channelsTV: [{
                        text: '节目',
                        key: 8,
                    }],
                    pubWays: [{
                        name: '客户端',
                        name_: 'METATYPEBYAPP'
                    }, {
                        name: '网站',
                        name_: 'METATYPEBYWEB',
                    }, {
                        name: '报纸',
                        name_: 'METATYPEBYPAPER',
                    }, {
                        name: '微博',
                        name_: 'METATYPEBYWEIBO',
                    }, {
                        name: '微信',
                        name_: 'METATYPEBYWECHAT',
                    }],
                    pubWaysTV: [{
                        name: '电视台',
                        name_: 'METATYPEBYTV',
                    }, {
                        name: '广播',
                        name_: 'METATYPEBYBROADCAST',
                    }],
                    canChooseGroup: angular.isUndefined(item.groupId),
                    // curUser: localStorageService.get('currLoginUser'), // session修改
                    curUser: $sessionStorage.get('currLoginUser'),
                    files: {
                        'extensions': 'txt,jpg,png,gif,jpeg,bmp,pdf,doc,docx,xlsx,ppt,pptx',
                        'mimetypes': 'text/plain,image/jpg,image/png,image/gif,image/jpeg,image/bmp,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation'
                    },
                    hasContent: false,
                    isVideoComplete: false,
                    isUploadError: false,
                    isVideo: false,
                    channelsData: item.channelsData ? item.channelsData : [],
                    channelsDataPubWay: [],
                    channelsDataPubWayTB: [],
                    channelsOtherStatus: false
                    // isAudioComplete:false
                };
                $scope.data = {
                    TITLE: '',
                    // STARTTIME: "",
                    // ENDTIME: "",
                    REPORTTYPE: 1,
                    METATYPEBYAPP: '',
                    // METATYPEBYAPPOTHER: "",
                    METATYPEBYWEB: '',
                    // METATYPEBYWEBOTHER: "",
                    METATYPEBYPAPER: '',
                    // METATYPEBYPAPEROTHER: "",
                    METATYPEBYOTHER: '',
                    METATYPEBYWEIBO: '', // 微博
                    METATYPEBYWECHAT: '', // 微信
                    METATYPEBYTV: '', // 电视台
                    METATYPEBYBROADCAST: '', // 广播
                    CONTENT: '',
                    VIDEOORAUDIO: [],
                    APPENDIX: [],
                    ISPASS: 0,
                    EXECUTOR: '',
                    GROUPTYPE: 0,
                    // RECOMMENDEDREASON:"",  //推荐理由
                    REPORTID: item.reportId, // 报题ID
                    GROUPID: item.groupId // 分组ID
                };
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                getChannelsData();
                initFrameUrl();
                getMedaiReleaseAddress();
                getData().then(function() {
                    initUeditor();
                    initMyGroup().then(function() {
                        return initRecomGroup();
                    }).then(function() {
                        getUserDeptUsers();
                    });
                });
            }

            /**
             * [initData description] 初始化发布渠道
             * @return {[type]} [description]
             */
            function getChannelsData() {
                if ($scope.status.channelsData.length > 0) {
                    $scope.status.channelsData = $scope.status.channelsData.map(function(v, k) {
                        var obj = {},
                            name_ = '';
                        switch (v.NAME) {
                            case '客户端':
                                name_ = 'METATYPEBYAPP';
                                break;
                            case '网站':
                                name_ = 'METATYPEBYWEB';
                                break;
                            case '报纸':
                                name_ = 'METATYPEBYPAPER';
                                break;
                            case '电视台':
                                name_ = 'METATYPEBYTV';
                                break;
                            case '广播':
                                name_ = 'METATYPEBYBROADCAST';
                                break;
                            case '微博':
                                name_ = 'METATYPEBYWEIBO';
                                break;
                            case '微信':
                                name_ = 'METATYPEBYWECHAT';
                                break;
                        }
                        obj = {
                            name: v.NAME,
                            name_: name_
                        };
                        return obj;
                    });
                    angular.forEach($scope.status.channelsData, function(v, k) {
                        if (v.name === '电视台' || v.name === '广播') {
                            $scope.status.channelsDataPubWayTB.push(v);
                        } else if (v.name == '其他') {
                            $scope.status.channelsOtherStatus = true;
                        } else {
                            $scope.status.channelsDataPubWay.push(v);
                        }
                    });
                }
            }

            /**
             * [getUserDept description] 获取执行人部门
             * @return {[type]} [description]
             */
            function getUserDeptUsers() {
                commandService.newInvoke('queryExcutorByDepart', { GroupId: $scope.data.GROUPID }).then(function(data) {
                    data = data.map(function(item) {
                        item.USER = angular.isArray(item.USER) ? item.USER : [item.USER];
                        return item;
                    });
                    $scope.status.userDept = data;
                    if (data.length > 0 && data[0].USER.length > 0 && !$scope.data.REPORTID) {
                        for (var j = 0; j < data.length; j++) {
                            for (var i = 0; i < data[j].USER.length; i++) {
                                var userName = data[j].USER[i].UserName === undefined ? data[j].USER[i].USERNAME : data[j].USER[i].UserName;
                                if (userName === $scope.status.curUser) {
                                    selectUser(data[j].USER[i]);
                                    break;
                                }
                            }
                        }
                    }
                });
            }

            /**
             * [selectUser description] 选择执行人
             * @return {[type]} [description]
             */
            function selectUser(user) {
                var usersArray = $scope.data.EXECUTOR === '' ? [] : $scope.data.EXECUTOR.split(',');
                var userId = angular.isUndefined(user.UserId) ? user.USERID : user.UserId;
                var index = usersArray.indexOf(userId.toString());
                if (index >= 0) {
                    usersArray.splice(index, 1);
                } else {
                    usersArray.push(userId);
                }
                $scope.data.EXECUTOR = usersArray.join(',');
            }
            $scope.selectUser = selectUser;

            /**
             * [getMyGroup description] 获取我的分组
             * @return {[type]} [description]
             */
            function initMyGroup() {
                var deffer = $q.defer();
                commandService.newInvoke('queryOwnerGroup', {}).then(function(data) {
                    if (data.length === 0) {
                        delete $scope.data.GROUPTYPE;
                        deffer.resolve();
                        return deffer.promise;
                    }
                    $scope.status.myGroups = data;
                    var selectedGroup = $scope.status.myGroups.filter(function(item) {
                        return item.GROUPID === $scope.data.GROUPID;
                    })[0];
                    $scope.status.defaultGroup = $scope.status.myGroups.filter(function(item) {
                        return item.ISDEFAULT === '1';
                    })[0];
                    if (angular.isDefined(selectedGroup)) {
                        $scope.status.myGroupSelected = selectedGroup;
                    } else if (angular.isDefined($scope.status.defaultGroup)) {
                        $scope.status.myGroupSelected = angular.copy($scope.status.defaultGroup);
                    } else {
                        $scope.status.myGroupSelected = angular.copy($scope.status.myGroups[0]);
                    }
                    if ($scope.data.GROUPTYPE === 0) {
                        $scope.data.GROUPID = $scope.status.myGroupSelected.GROUPID;
                    }
                    deffer.resolve();
                });
                return deffer.promise;
            }

            /**
             * [setDefault description] 设为默认
             */
            $scope.setDefault = function() {
                var flag = angular.isDefined($scope.status.defaultGroup) && $scope.status.myGroupSelected.GROUPID === $scope.status.defaultGroup.GROUPID;
                if (flag) {
                    delete $scope.status.defaultGroup;
                } else {
                    commandService.newInvoke('addDefaultGroup', { GroupId: $scope.status.myGroupSelected.GROUPID }).then(function(data) {
                        $scope.status.defaultGroup = angular.copy($scope.status.myGroupSelected);
                    });
                }
            };

            /**
             * [initRecomGroup description] 推荐分组
             * @return {[type]} [description]
             */
            function initRecomGroup() {
                var deffer = $q.defer();
                commandService.newInvoke('queryRecommendGroup', {}).then(function(data) {
                    if (data.length === 0) {
                        deffer.resolve();
                        return deffer.promise;
                    }
                    if ($scope.data.GROUPTYPE === undefined) {
                        $scope.data.GROUPTYPE = 1;
                    }
                    $scope.status.recomGroups = data;
                    var selectedGroup = $scope.status.recomGroups.filter(function(item) {
                        return item.NEWGROUPID === $scope.data.GROUPID;
                    })[0];
                    $scope.status.recomGroupSelected = angular.isDefined(selectedGroup) ? selectedGroup : angular.copy($scope.status.recomGroups[0]);
                    if ($scope.data.GROUPTYPE === 1) {
                        $scope.data.GROUPID = $scope.status.recomGroupSelected.NEWGROUPID;
                    }
                    deffer.resolve();
                });
                return deffer.promise;
            }

            /**
             * [selectRecomGroup description] 选择推荐分组 分组项
             * @return {[type]} [description]
             */
            $scope.selectRecomGroup = function() {
                if ($scope.data.GROUPTYPE === 1) {
                    $scope.data.GROUPID = $scope.status.recomGroupSelected.NEWGROUPID;
                    $scope.data.EXECUTOR = '';
                    getQueryChannels().then(function(res) {
                        if (res.length > 0){
                            $scope.status.channelsData = res;
                            $scope.status.channelsDataPubWayTB = [];
                            $scope.status.channelsOtherStatus = false;
                            $scope.status.channelsDataPubWay = [];
                            groupInitial();
                            getChannelsData();
                        }
                    });
                    getUserDeptUsers();
                }
            };

            /**
             * [chooseMyGroupType description] 选择我的分组
             * @return {[type]} [description]
             */
            $scope.chooseRecomGroupType = function() {
                $scope.data.GROUPTYPE = 1;
                $scope.data.GROUPID = $scope.status.recomGroupSelected.NEWGROUPID;
                $scope.data.EXECUTOR = '';
                getUserDeptUsers();
            };

            /**
             * 获得分组信息
             * @returns {Promise}
             */
            function getQueryChannels() {
                var defer = $q.defer();
                commandService.newInvoke('queryChannels', { GroupId: $scope.data.GROUPID }).then(function(data) {
                    defer.resolve(data);
                });
                return defer.promise;
            }

            /**
             * 设置分组初始化
             */
            function groupInitial(){
                $scope.data.METATYPEBYAPP = '';
                $scope.data.METATYPEBYAPPOTHER = undefined;
                $scope.data.METATYPEBYWEB = '';
                $scope.data.METATYPEBYWEBOTHER = undefined;
                $scope.data.METATYPEBYPAPER = '';
                $scope.data.METATYPEBYPAPEROTHER = undefined;
                // 微博
                $scope.data.METATYPEBYWEIBO = '';
                $scope.data.METATYPEBYWEIBOOTHER = undefined;
                // 微信
                $scope.data.METATYPEBYWECHAT = '';
                $scope.data.METATYPEBYWECHATOTHER = undefined;
                // 电视台
                $scope.data.METATYPEBYTV = '';
                $scope.data.METATYPEBYTVOTHER = undefined;
                // 广播
                $scope.data.METATYPEBYBROADCAST = '';
                $scope.data.METATYPEBYBROADCASTOTHER = undefined;
            }

            /**
             * [selectMyGroup description] 选择我的分组 分组项
             * @return {[type]} [description]
             */
            $scope.selectMyGroup = function() {
                if ($scope.data.GROUPTYPE === 0) {
                    $scope.data.GROUPID = $scope.status.myGroupSelected.GROUPID;
                    $scope.data.EXECUTOR = '';
                    getQueryChannels().then(function(res) {
                        if (res.length > 0){
                            $scope.status.channelsData = res;
                            $scope.status.channelsDataPubWayTB = [];
                            $scope.status.channelsOtherStatus = false;
                            $scope.status.channelsDataPubWay = [];
                            groupInitial();
                            getChannelsData();
                        }
                    });
                    getUserDeptUsers();
                }
            };

            /**
             * [chooseMyGroupType description] 选择我的分组
             * @return {[type]} [description]
             */
            $scope.chooseMyGroupType = function() {
                $scope.data.GROUPTYPE = 0;
                $scope.data.GROUPID = $scope.status.myGroupSelected.GROUPID;
                $scope.data.EXECUTOR = '';
                getUserDeptUsers();
            };

            /** [initFrameUrl description]初始化iframe地址 */
            function initFrameUrl() {
                var iframeParams = {
                    'serviceid': 'mlf_videoInterfacesEncapsulation',
                    'methodname': 'videoIframe',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), iframeParams, 'post').then(function(data) {
                    data = data.URL;
                    $scope.status.videoIFrame = $sce.trustAsResourceUrl(data);
                });
                var audioParams = {
                    'serviceid': 'mlf_videoInterfacesEncapsulation',
                    'methodname': 'audioIframe',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), audioParams, 'post').then(function(data) {
                    data = data.URL;
                    $scope.status.audioIFrame = $sce.trustAsResourceUrl(data);
                });
            }

            /**
             * [getMedaiReleaseAddress description]获取不同环境下的媒资服务域名
             * @return {[type]} [description]
             */
            function getMedaiReleaseAddress() {
                $scope.status.releaseAddress = location.protocol + '//' + location.host;
                // var params = {
                //     serviceid: 'mlf_videoInterfacesEncapsulation',
                //     methodname: 'getMedaiReleaseAddress'
                // };
                // trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                //     $scope.status.releaseAddress = data.URL;
                // });
            }

            /**
             * [getData description] 获取报题数据
             * @return {[type]} [description]
             */
            function getData() {
                var deffer = $q.defer();
                if ($scope.data.REPORTID) {
                    commandService.newInvoke('queryReport', { ReportId: $scope.data.REPORTID }).then(function(data) {
                        delete data.CRTIME;
                        delete data.CRUSER;
                        delete data.CRUSERNAME;
                        delete data.METADATAINFO;
                        delete data.REPLIESINFO;
                        for (var i in data.APPENDIXINFO) {
                            var appendix = data.APPENDIXINFO[i];
                            if (appendix.REPORTAPPTYPE === '3' || appendix.REPORTAPPTYPE === '5') {
                                $scope.data.VIDEOORAUDIO.push({ File: appendix.REPORTAPPFILE, Name: appendix.REPORTAPPDESC, Type: appendix.REPORTAPPTYPE });
                            } else {
                                var imgSrcArray = appendix.REPORTAPPFILE.split('/');
                                var imgName = imgSrcArray[imgSrcArray.length - 1];
                                $scope.data.APPENDIX.push({ File: imgName, Name: appendix.REPORTAPPDESC, Size: appendix.FILESIZE });
                            }
                        }
                        delete data.APPENDIXINFO;
                        data.METATYPEBYOTHER = data.METATYPEINFO[0].METATYPEBYOTHER;
                        data.METATYPEBYAPP = data.METATYPEINFO[0].METATYPEBYAPP;
                        data.METATYPEBYAPPOTHER = data.METATYPEINFO[0].METATYPEBYAPPOTHER;
                        data.METATYPEBYWEB = data.METATYPEINFO[0].METATYPEBYWEB;
                        data.METATYPEBYWEBOTHER = data.METATYPEINFO[0].METATYPEBYWEBOTHER;
                        data.METATYPEBYPAPER = data.METATYPEINFO[0].METATYPEBYPAPER;
                        data.METATYPEBYPAPEROTHER = data.METATYPEINFO[0].METATYPEBYPAPEROTHER;
                        // 微博
                        data.METATYPEBYWEIBO = data.METATYPEINFO[0].METATYPEBYWEIBO;
                        data.METATYPEBYWEIBOOTHER = data.METATYPEINFO[0].METATYPEBYWEIBOOTHER;
                        // 微信
                        data.METATYPEBYWECHAT = data.METATYPEINFO[0].METATYPEBYWECHAT;
                        data.METATYPEBYWECHATOTHER = data.METATYPEINFO[0].METATYPEBYWECHATOTHER;
                        // 电视台
                        data.METATYPEBYTV = data.METATYPEINFO[0].METATYPEBYTV;
                        data.METATYPEBYTVOTHER = data.METATYPEINFO[0].METATYPEBYTVOTHER;
                        // 广播
                        data.METATYPEBYBROADCAST = data.METATYPEINFO[0].METATYPEBYBROADCAST;
                        data.METATYPEBYBROADCASTOTHER = data.METATYPEINFO[0].METATYPEBYBROADCASTOTHER;
                        data.REPORTTYPE = Number(data.REPORTTYPE);
                        delete data.METATYPEINFO;
                        data.EXECUTOR = data.EXECUTOR.map(function(item) {
                            return item.USERID;
                        }).join(',');
                        data.GROUPTYPE = Number(data.GROUPTYPE);
                        angular.extend($scope.data, data);
                        deffer.resolve();
                    });
                } else {
                    deffer.resolve();
                }
                return deffer.promise;
            }

            /**
             * [chooseOtherWay description] 勾选其他媒体
             * @param {[object]} [pubWay] [description] 渠道类型
             * @return {[type]} [description]
             */
            $scope.chooseOtherWay = function(pubWay) {
                if (angular.isDefined($scope.data[pubWay.name_ + 'OTHER'])) {
                    delete $scope.data[pubWay.name_ + 'OTHER'];
                } else {
                    $scope.data[pubWay.name_ + 'OTHER'] = '';
                }
            };

            /**
             * [chooseChannel description] 选择发布媒体
             * @param  {[type]} pubWay  [description]  发布渠道
             * @param  {[type]} channel [description]  发布媒体
             * @return {[type]}         [description]
             */
            $scope.chooseChannel = function(pubWay, channel) {
                var channelArray = !$scope.data[pubWay.name_] ? [] : $scope.data[pubWay.name_].split(',');
                var index = channelArray.indexOf(channel.key.toString());
                if (index >= 0) {
                    channelArray.splice(index, 1);
                } else {
                    channelArray.push(channel.key);
                }
                $scope.data[pubWay.name_] = channelArray.join(',');
            };

            /**
             * [initUeditor description] 初始化编辑器
             * @return {[type]} [description]
             */
            function initUeditor() {
                LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.5'], function() {
                    var ueditor = '<ueditor-for-command html-content="data.CONTENT" has-content="status.hasContent"></ueditor-for-command>';
                    ueditor = $compile(ueditor)($scope);
                    $($(angular.element(document)).find('ueditorLocation')).append(ueditor);
                    $scope.status.ue = UE.getEditor('ueditor');
                });
            }

            /** [uploadAudio description] 上传音频 */
            $scope.uploadAudio = function() {
                $scope.audioNeed = false;
                $scope.status.isVideoComplete = false;
                initListenAudio();
                window.frames[1].postMessage('upload', $scope.status.releaseAddress);
            };

            /** [uploadVideo description] 上传视频 */
            $scope.uploadVideo = function() {
                $scope.videoNeed = false;
                $scope.status.isVideoComplete = false;
                initListenVideo();
                window.frames[0].postMessage('upload', $scope.status.releaseAddress);
            };

            /** [initListenVideo description]初始化监听视频的回传的监听事件 */
            function initListenVideo() {
                window.addEventListener('message', addVideoResource);
                $scope.$on('$destroy', function() {
                    window.removeEventListener('message', addVideoResource);
                });
            }

            /** [initListenVideo description]初始化监听视频的回传的监听事件 */
            function initListenAudio() {
                window.addEventListener('message', addAudioResource);
                $scope.$on('$destroy', function() {
                    window.removeEventListener('message', addAudioResource);
                });
            }

            /** [addAudioResource description]监听音频上传 */
            function addAudioResource(e) {
                if (!!e && angular.isString(e.data) && e.data.indexOf('audio') > -1) {
                    $scope.status.isVideo = true;
                    var msg = e.data;
                    if (msg.indexOf('progress') > -1) {
                        $timeout(function() {
                            if (!$scope.audioNeed) {
                                $scope.data.VIDEOORAUDIO.push({ File: 0, Name: '音频正在上传', Type: '5' });
                                $scope.audioNeed = true;
                            }
                        });
                    } else if (msg.indexOf('complete') > -1) {
                        $scope.status.isVideoComplete = true;
                        var id = msg.split('=')[1],
                            num = $scope.data.VIDEOORAUDIO.length;
                        getVideoInfo(id, 'audio/mp3').then(function(data) {
                            $scope.data.VIDEOORAUDIO[num - 1].File = id;
                            $scope.data.VIDEOORAUDIO[num - 1].Name = data.DATA.filename;
                            $scope.data.VIDEOORAUDIO[num - 1].Type = '5';
                        });
                    } else if (msg.indexOf('type') > -1) {
                        modalDialog.alertType('上传失败', '请按照要求上传文件!', 'info', false);
                        return;
                    }
                }
            }

            /** [addVideoResource description] 监听添加视频操作*/
            function addVideoResource(e) {
                if (!!e && angular.isString(e.data) && e.data.indexOf('video') > -1) {
                    $scope.status.isVideo = true;
                    var msg = e.data;
                    if (msg.indexOf('progress') > -1) {
                        $timeout(function() {
                            if (!$scope.videoNeed) {
                                $scope.data.VIDEOORAUDIO.push({ File: 0, Name: '视频正在上传', Type: '3' });
                                $scope.videoNeed = true;
                            }
                        });
                    } else if (msg.indexOf('complete') > -1) {
                        $scope.status.isVideoComplete = true;
                        var id = msg.split('=')[1],
                            num = $scope.data.VIDEOORAUDIO.length;
                        getVideoInfo(id, 'video/mp4').then(function(data) {
                            $scope.data.VIDEOORAUDIO[num - 1].File = id;
                            $scope.data.VIDEOORAUDIO[num - 1].Name = data.DATA.filename;
                            $scope.data.VIDEOORAUDIO[num - 1].Type = '3';
                        });
                    } else if (msg.indexOf('type') > -1) {
                        modalDialog.alertType('上传失败', '请按照要求上传文件!', 'info', false);
                        return;
                    }
                }
            }

            /** [processing description] 获取视频信息*/
            function getVideoInfo(id, type) {
                var deffer = $q.defer(),
                    params = {
                        serviceid: 'mlf_videoInterfacesEncapsulation',
                        methodname: 'getVideoUrl',
                        VideoId: id,
                        resourceType: type
                    };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    deffer.resolve(data);
                });
                return deffer.promise;
            }

            /**
             * [cancelAudio description] 取消或删除上传音频
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.deleteAudio = function(item) {
                var num = $scope.data.VIDEOORAUDIO.indexOf(item);
                if (num > -1) {
                    $scope.data.VIDEOORAUDIO.splice(num, 1);
                }
                window.removeEventListener('message', addAudioResource);
            };

            /** [cancelAudio description]删除正在上传中的视频 */
            $scope.deleteVideo = function(item) {
                var num = $scope.data.VIDEOORAUDIO.indexOf(item);
                if (num > -1) {
                    $scope.data.VIDEOORAUDIO.splice(num, 1);
                }
                window.removeEventListener('message', addVideoResource);
            };

            /**
             * [uploadCallback description] 上传附件
             * @type {Object}
             */
            $scope.uploadCallback = {
                success: function(file, src, uploader) {
                    if (src.success) {
                        $scope.data.APPENDIX = $scope.data.APPENDIX.concat(file);
                        $timeout(function() {
                            $scope.data.APPENDIX = $scope.data.APPENDIX.map(function(item) {
                                if (item.id === file.id) {
                                    return {
                                        Name: file.name,
                                        File: src.imgName,
                                        Size: src.fileSizeOfKB
                                    };
                                } else {
                                    return item;
                                }
                            });
                        });
                    } else {
                        if ($scope.status.isUploadError) {
                            $timeout(function() {
                                modalDialog.alertType(src.error, '', 'warning', false);
                            }, 1000);
                        } else {
                            modalDialog.alertType(src.error, '', 'warning', false);
                        }

                    }
                },
                error: function(file) {
                    $scope.deleteAppendix(file);
                    modalDialog.alertType('上传文件失败,请重传', '', 'warning', false);
                },
                file: function(file, uploader) {
                    var theFile = [];
                    $scope.status.isUploadError = false;
                    for (var i = 0; i < file.length; i++) {
                        if (!file[i].error) {
                            theFile.push(file[i]);
                        } else {
                            $scope.status.isUploadError = true;
                            modalDialog.alertType(file[i].error, '', 'warning', false);
                        }
                    }
                    if (theFile.length !== 0) {
                        $timeout(function() {
                            // $scope.data.APPENDIX = $scope.data.APPENDIX.concat(theFile);
                            uploader.upload();
                        });
                    }
                },
                tar: function(file, percent) {

                },
                comp: function(file) {}
            };

            /**
             * [deleteAppendix description] 删除附件
             * @param  {[type]} appendix [description]
             * @return {[type]}          [description]
             */
            $scope.deleteAppendix = function(appendix) {
                $scope.data.APPENDIX = $scope.data.APPENDIX.filter(function(item) {
                    return item.Name != appendix.Name || item.id != item.id;
                });
            };

            /**
             * [close description] 关闭弹窗
             * @return {[type]} [description]
             */
            $scope.close = function() {
                $modalInstance.dismiss();
            };

            /**
             * [confirm description] 提交
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                $scope.data.CONTENT = $scope.status.ue.getContent();
                $scope.reportForm.$pending = {};
                $validation.validate($scope.reportForm).success(function() {
                    var params = handleParams();
                    var url = angular.isDefined($scope.data.REPORTID) ? 'editReport' : 'saveReport';

                    function tranReportData() {
                        $scope.loadingPromise = commandService.newInvoke(url, params).then(function(data) {
                            var title = angular.isDefined($scope.data.REPORTID) ? '编辑' : '添加';
                            if (data.ISSUCCESS === 'true') {
                                modalDialog.alertType(title + '成功', '', 'success', false, function() {
                                    $modalInstance.close(params.GroupId, params);
                                });
                            }
                        });
                    }
                    if ($scope.status.isVideo) {
                        if ($scope.status.isVideoComplete) {
                            tranReportData();
                        } else {
                            modalDialog.alertType('上传文件未完成', '', 'warning', false);
                        }
                    } else {
                        tranReportData();
                    }
                }).error(function() {
                    angular.invalidPosition($scope.reportForm, $element);
                });
            };

            /**
             * [handleParams description] 处理将要提交的表单参数
             * @return {[type]} [description]
             */
            function handleParams() {
                var params = angular.copy($scope.data);
                for (var i in params) {
                    var obj = params[i];
                    if (angular.isObject(obj)) {
                        params[i] = JSON.stringify(obj);
                    }
                }
                return params;
            }
        }
    ]);
